import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef } from 'react';
import Input from '../../Input/index.js';
import BaseAutocomplete from '../BaseAutocomplete/index.js';
import SelectOption from '../components/SelectOption/index.js';
import SelectTag from '../components/SelectTag/index.js';
import { defaultOptionLabelRenderer, defaultTagLabelRenderer } from './renderers.js';

var _excluded = ["getOptionLabel", "multiple", "optionLabelRenderer", "size", "tagLabelRenderer"];
var Autocomplete = function Autocomplete(props, ref) {
  var getOptionLabel = props.getOptionLabel,
    multiple = props.multiple,
    optionLabelRenderer = props.optionLabelRenderer,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    tagLabelRenderer = props.tagLabelRenderer,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var renderInput = function renderInput(params) {
    return /*#__PURE__*/React__default.createElement(Input, _extends({}, params));
  };
  var renderOption = function renderOption(option, state) {
    var label;
    if (optionLabelRenderer) {
      label = optionLabelRenderer(option, state);
    } else {
      label = defaultOptionLabelRenderer(getOptionLabel(option), state, size);
    }
    return /*#__PURE__*/React__default.createElement(SelectOption, {
      label: label,
      multiple: multiple,
      size: size,
      state: state
    });
  };
  var renderTags = function renderTags(options, getTagProps) {
    return options.map(function (option, index) {
      var label;
      if (tagLabelRenderer) {
        label = tagLabelRenderer(option);
      } else {
        label = defaultTagLabelRenderer(getOptionLabel(option), size);
      }
      return /*#__PURE__*/React__default.createElement(SelectTag, _extends({
        label: label,
        size: size
      }, getTagProps({
        index: index
      })));
    });
  };
  return /*#__PURE__*/React__default.createElement(BaseAutocomplete, _extends({
    ref: ref,
    openOnFocus: true,
    disableCloseOnSelect: multiple,
    getOptionLabel: getOptionLabel,
    multiple: multiple,
    renderInput: renderInput,
    renderOption: renderOption,
    renderTags: renderTags,
    size: size
  }, rest));
};
var Autocomplete$1 = /*#__PURE__*/forwardRef(Autocomplete);

export { Autocomplete$1 as default };
//# sourceMappingURL=index.js.map
